// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__Smku1","slider":"style_slider__yYIPO","round":"style_round__MKB2X"};